/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon16Light = forwardRef('TextBulletIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M6 3.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M6.5 7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" }),
        React.createElement("path", { d: "M6.5 11a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" }),
        React.createElement("path", { d: "M4 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M3 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
